<template>
	<div class="wutuNew2">
		<ul>
			<li v-for="(item,index) in dataList" :key='item.ID'>
				<router-link  :to="item.Url" :href="item.Url"  class="flexDiv">
					<p class="times">
						<i>{{item.ShowTime2}}</i>
						<em>{{setTimeformat(item.ShowTime6,'YYYY-mm')}}</em>
					</p>
					<span>{{item.Title}}</span>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'noImgList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/noImgList2.vue